import { gql, useQuery } from '@apollo/client';

import { UserApiKeysCardFragment } from 'src/app/user/settingsPage/apiKeySettings/userApiKeysCard/UserApiKeysCard';
import { BetaFeaturesCardUserFragment } from 'src/app/user/settingsPage/generalSettings/betaFeaturesCardSettings/BetaFeaturesCardSettings';
import { DeleteUserCardUserFragment } from 'src/app/user/settingsPage/generalSettings/deleteUserCardSettings/DeleteUserCardSettings';
import { EmailCardUserFragment } from 'src/app/user/settingsPage/generalSettings/emailCardSettings/EmailCardSettings';
import { NameCardUserFragment } from 'src/app/user/settingsPage/generalSettings/nameCardSettings/NameCardSettings';
import { OrganizationsCardSettingsFragment } from 'src/app/user/settingsPage/generalSettings/organizationsCardSettings/OrganizationsCardSettings';
import { PasswordCardSettingsFragment } from 'src/app/user/settingsPage/generalSettings/passwordCardSettings/PasswordCardSettings';
import { ignorePermissionsErrors } from 'src/lib/apollo/catchErrors';
import { appLinkContext } from 'src/lib/apollo/link';
import {
  User__PersonalSettingsQuery,
  User__PersonalSettingsQueryVariables,
} from 'src/lib/graphqlTypes/types';

export function usePersonalSettingsQuery() {
  const personalSettingsResult = useQuery<
    User__PersonalSettingsQuery,
    User__PersonalSettingsQueryVariables
  >(
    gql`
      query User__PersonalSettingsQuery {
        me {
          id
          ... on User {
            type
          }
          ...NameCardUserFragment
          ...EmailCardUserFragment
          ...DeleteUserCardUserFragment
          ...OrganizationsCardSettingsFragment
          ...PasswordCardSettingsFragment
          ...UserApiKeysCardFragment
          ...BetaFeaturesCardUserFragment
        }
      }
      ${NameCardUserFragment}
      ${EmailCardUserFragment}
      ${DeleteUserCardUserFragment}
      ${OrganizationsCardSettingsFragment}
      ${PasswordCardSettingsFragment}
      ${UserApiKeysCardFragment}
      ${BetaFeaturesCardUserFragment}
    `,
    {
      context: appLinkContext({ catchErrors: [ignorePermissionsErrors] }),
    },
  );

  return personalSettingsResult;
}
